import { Injectable } from "@angular/core";
import {
  ACTION_TARGET,
  AVAILABLE_ACTIONS,
  ICareplan,
  ICareplanKnowledgeInfos,
  IKnowledgesCriteria,
  ILink2Careplan,
  IlinkableObsItem,
  IlinkableQuestionnaireItem,
  IReference,
  ITranslation,
  KNOW_DOC_CATEGORY,
} from "@comunicare/comunicare-interfaces";
import { ICareplanEditorService } from "@comunicare/comunicare-interfaces-dashboard-services";
import { BehaviorSubject, Observable, Subject } from "rxjs";

/* tslint:disable:no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* tslint:disable:no-explicit-any */
/* eslint-disable @typescript-eslint/no-explicit-any */
@Injectable({
  providedIn: "root",
})
export class CareplanEditorService implements ICareplanEditorService {
  currentCareplanTemplate: ICareplan;
  careplanTemplateReady$: BehaviorSubject<boolean>;
  link2CareplanReady$: Subject<boolean>;
  link2CareplanForm: any;
  careplanTemplateForm: any;
  lastSaveDate: number;
  availableLangs: ITranslation[];
  isJsonView: boolean;
  getCareplanTemplate(
    careplanRef: string,
    withDraft: boolean,
    publicationDate?: string
  ): Observable<{ published: ICareplan; draft: ICareplan }> {
    throw new Error("Method not implemented.");
  }
  setCareplanTemplateReady(value: boolean): void {
    throw new Error("Method not implemented.");
  }
  setLink2CareplanReady(value: boolean): void {
    throw new Error("Method not implemented.");
  }
  createCareplanTemplateObj(services: IReference[]): ICareplan {
    throw new Error("Method not implemented.");
  }
  initCareplanTemplateForm(careplanTemplate: ICareplan): void {
    throw new Error("Method not implemented.");
  }
  createLink2CareplanObj(careplanRef: string): ILink2Careplan {
    throw new Error("Method not implemented.");
  }
  createCareplanTemplate(careplanTemplate: ICareplan): Observable<ICareplan> {
    throw new Error("Method not implemented.");
  }
  createLink2Careplan(link2Careplan: ILink2Careplan): Observable<ILink2Careplan> {
    throw new Error("Method not implemented.");
  }
  getLink2Careplan(careplanId: string, withDraft: boolean): Observable<{ published: ILink2Careplan; draft: ILink2Careplan }> {
    throw new Error("Method not implemented.");
  }
  initLink2CareplanForm(): void {
    throw new Error("Method not implemented.");
  }
  getCareplanKnowledgeInfos(
    careplanId: string,
    draft: boolean,
    docCategories: KNOW_DOC_CATEGORY[],
    publicationDate?: string
  ): Observable<ICareplanKnowledgeInfos[]> {
    throw new Error("Method not implemented.");
  }
  initTraductions(availableLangs: string[]): Observable<ITranslation[]> {
    throw new Error("Method not implemented.");
  }
  saveTraductions(availableLangs: string[]): Observable<unknown> {
    throw new Error("Method not implemented.");
  }
  updateCareplanTemplate(careplanTemplate: ICareplan): Observable<ICareplan> {
    throw new Error("Method not implemented.");
  }
  publishCareplanTemplate(careplanTemplateRef: string): Observable<ICareplan> {
    throw new Error("Method not implemented.");
  }
  publishLink2CareplanTemplate(careplanTemplateRef: string): Observable<ILink2Careplan> {
    throw new Error("Method not implemented.");
  }
  publishKnowledgeCriteria(careplanTemplateRef: string): Observable<unknown> {
    throw new Error("Method not implemented.");
  }
  save(publish: boolean, close?: boolean, isJsonImport?: boolean, updateCriteria?: boolean): void {
    throw new Error("Method not implemented.");
  }
  silentSave(): Promise<ICareplan> {
    throw new Error("Method not implemented.");
  }
  update(
    $event: {
      item: IlinkableQuestionnaireItem | IlinkableObsItem;
      items: IlinkableQuestionnaireItem[] | IlinkableObsItem[];
      action: AVAILABLE_ACTIONS;
    },
    actionTarget: ACTION_TARGET
  ): Promise<void> {
    throw new Error("Method not implemented.");
  }
  linkOrUnlinkItem(
    $event: {
      item: IlinkableQuestionnaireItem | IlinkableObsItem;
      items: IlinkableQuestionnaireItem[] | IlinkableObsItem[];
      action: AVAILABLE_ACTIONS;
    },
    actionTarget: ACTION_TARGET
  ): Promise<void> {
    throw new Error("Method not implemented.");
  }
  handleUnlinkFromCareplan(
    item: IlinkableQuestionnaireItem | IlinkableObsItem,
    items: IlinkableQuestionnaireItem[] | IlinkableObsItem[],
    actionTarget: ACTION_TARGET
  ): Promise<void> {
    throw new Error("Method not implemented.");
  }
  reset(): void {
    throw new Error("Method not implemented.");
  }
  updateCareplanWithKnowledgeCriteria(previousCriteria: IKnowledgesCriteria[]): Promise<void> {
    throw new Error("Method not implemented.");
  }
}
